import { ONFIDO_DOC_TYPE_PASSPORT } from 'constants/Onfido';

const getSteps = (documentTypes = {}, addSelfie = true) => {
    const stepsArray = [];
    stepsArray.push({
        type: 'document',
        options: {
            documentTypes: documentTypes,
            hideCountrySelection: true,
        },
    });
    if (addSelfie) {
        stepsArray.push('face');
    }
    stepsArray.push('complete');
    return stepsArray;
};

const getGT_Steps = (docInfo, addSelfie = true, addMotion = false) => {
    const stepsArray = [];

    if (docInfo) {
        stepsArray.push({
            type: 'document',
            options: {
                documentTypes: { [docInfo?.type]: true },
                hideCountrySelection: true,
            },
        });
    } else {
        stepsArray.push({
            type: 'document',
        });
    }

    if (addMotion) {
        stepsArray.push({
            type: 'face',
            options: {
                requestedVariant: 'motion',
            },
        });
    } else if (addSelfie) {
        stepsArray.push('face');
    }

    stepsArray.push('complete');
    return stepsArray;
};

const getMotionStep = () => {
    const stepsArray = [];

    stepsArray.push({
        type: 'face',
        options: {
            requestedVariant: 'motion',
        },
    });

    stepsArray.push('complete');
    return stepsArray;
};

const getThemeConfig = (theme) => {
    if (theme === 'dark') {
        return {
            colorBackgroundSurfaceModal: '#20252CFF',
            colorContentBody: '#FFFFFFFF',
            colorContentTitle: '#FFFFFFFF',
            colorContentSubtitle: '#FFFFFFFF',
            colorContentButtonPrimaryText: '#FFFFFFFF',
            colorContentButtonSecondaryText: '#FFFFFFFF',
            colorContentDocTypeButton: '#FFFFFFFF',
            colorBackgroundInput: '#3C3C3CFF',
            colorContentInput: '#FFFFFFFF',
        };
    } else {
        return null;
    }
};

export class OnfidoService {
    static init = (Onfido, accessToken, options, onComplete, onError, theme) => {
        return Onfido.init({
            token: accessToken,
            containerId: 'onfido-mount',
            customUI: getThemeConfig(theme),
            onComplete: onComplete,
            steps: options,
            onError: onError,
        });
    };

    static getGtOptions = () => {
        return {
            steps: ['welcome', 'document', 'complete'],
        };
    };

    static getCanadianOptions = (docInfo, requiredSelfie = []) => {
        const docType = docInfo?.type;
        const addSelfie = requiredSelfie?.length > 0;
        const documentTypes = { [docType]: true };
        return getSteps(documentTypes, addSelfie);
    };

    static getGT_Options = (docInfo, requiredSelfie = []) => {
        const addSelfie = requiredSelfie?.length > 0;
        return getGT_Steps(docInfo, addSelfie, false);
    };

    static getOptionsForPassport = () => {
        return getSteps({ [ONFIDO_DOC_TYPE_PASSPORT]: true }, true);
    };

    static getFraudOptions = (docInfo, docsParam) => {
        const motionRequired = docsParam?.motionRequired;
        const addSelfie = docsParam?.requiredSelfie?.length > 0;

        if (docsParam?.identificationRequired) {
            return getGT_Steps(docInfo, addSelfie, motionRequired);
        }

        return getMotionStep();
    };

    static getRecipientFraudOptions = (docInfo, docsParam) => {
        const motionRequired = docsParam?.motionRequired;

        return getGT_Steps(docInfo, false, motionRequired);
    };

    static getMotionFraudOption = () => {
        const stepsArray = [];

        stepsArray.push({
            type: 'face',
            options: {
                requestedVariant: 'motion',
            },
        });
        return stepsArray;
    };
}
